<template>
    <div class="row">
        <div class="col-xs-12 col-sm-4  q-pa-md" v-for="(item, index) in filteredNews" :key="index">
            <q-card class="full-width full-height">
                <q-card-media @click.native="openNews(item)" class="cursor-pointer">
                    <img :src="item.image" v-if="item.image">
                    <img :src="getPlaceholder" v-if="!item.image">
                </q-card-media>

                <q-card-main style="min-height: 150px;">
                    <p class="q-subheading text-weight-medium text-primary title-library">{{ item.title }}</p>
                    <p class="text-faded q-mt-md">{{ fDate(item.publish_date) }}</p>
                </q-card-main>

                <q-card-separator />

                <q-card-actions class="justify-center">
                    <q-btn class="full-width q-my-sm" :label="$t('open')" icon="far fa-eye" color="secondary" @click.native="openNews(item)" />
                </q-card-actions>
            </q-card>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: {
            news:Array,
            news_loaded:Boolean,
            home:Boolean,
            page_news:{
               type: Boolean,
               default: false
            }
    },

    data() {
        return {

        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            id_user_language_selected: 'common/id_user_language_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        filteredNews() {
            let news = Object.assign([], this.news)
            if (this.home) {
                return news.slice(0, 5)
            }
            else return news
        },

        title_news(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_news == "" ? 'news' : obj.title_news
				}
			}
        },

        getPlaceholder() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
                this.card_image = client.news_placeholder
                return client.news_placeholder
            }
			else return ''
        },
    },

    methods: {
        openNews(item) {
            this.$emit('openNews', item)
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY'
                    break
                    default: format = 'MM-DD-YYYY'
                    break
                }

                return date.formatDate(d, format)
            }
        }
    },
}
</script>

<style>

</style>
